module.exports = __webpack_public_path__ + "static/media/dcu.2233f74b.png";